import { mkQcsSyncResourceStore } from 'data/qcsSyncResourceTypes';
import { handleActions, combineActions } from 'redux-actions';
import { upsertResourceSetupUndo, upsertResource, upsertResources, completeWithError, resetResources } from 'data/qcsSyncResourceReducerHelpers';
import { transformRequestDataToTransaction } from 'data/transactions/transformers';
import { mkScheduledTransaction, mkRecurrence } from 'data/scheduledTransactions/scheduledTransactionsTypes';
import { deleteAccount, deleteAccountSuccess, deleteAccountFailure } from 'data/accounts/actions';

import * as actions from './scheduledTransactionsActions';

const scheduledTransactionsReducer = handleActions({

  [actions.createScheduledTransaction]:
    (state, { payload: scheduledTransaction }) => upsertResource(state, scheduledTransaction),
  [actions.createScheduledTransactionSuccess]:
    (state, action) => upsertResourceSetupUndo(state, action, actions.deleteScheduledTransaction),

  [actions.updateScheduledTransaction]:
    (state, action) => upsertResourceSetupUndo(state, action, actions.updateScheduledTransaction),
  [actions.updateScheduledTransactionSuccess]:
    (state, { payload: scheduledTransaction }) => upsertResource(state, scheduledTransaction),

  [actions.deleteScheduledTransaction]:
    (state, action) => upsertResourceSetupUndo(state, action, actions.createScheduledTransaction),
  [actions.deleteScheduledTransactionSuccess]:
    (state, { payload: scheduledTransaction }) => upsertResource(state, scheduledTransaction),

  [combineActions(
    actions.createScheduledTransactionFailure,
    actions.updateScheduledTransactionFailure,
    actions.deleteScheduledTransactionFailure,
    deleteAccountFailure,
  )]: (state, {payload: error, asyncDispatch}) => {
    asyncDispatch(actions.getScheduledTransactions());
    return resetResources(state, error);
  },

  [actions.getScheduledTransactions]:
    (state) => state.merge({ isLoading: true }),
  [actions.getScheduledTransactionsSuccess]:
    (state, { payload: resources }) => upsertResources(state, resources),
  [actions.getScheduledTransactionsFailure]:
    (state, { payload: error }) => completeWithError(state, error),

  [actions.createBillScoutScheduleSuccess]:
    (state, action) => {
      let newState = state;
      if (action.meta && action.meta.response && action.meta.response.data && action.meta.response.data.schedule) {
        const createScheduledTransactionAction = {
          ...action,
          payload: mkScheduledTransaction({
            ...action.meta.response.data.schedule,
            clientId: action.payload.clientId,
            recurrence: mkRecurrence({ ...action.meta.response.data.schedule.recurrence }),
            transaction: transformRequestDataToTransaction(action.meta.response.data.schedule.transaction),
          }),
        };
        newState = upsertResourceSetupUndo(state, createScheduledTransactionAction, actions.deleteScheduledTransaction);
      }
      return newState;
    },
  [actions.createBillScoutScheduleFailure]:
    (state, { payload: error }) => completeWithError(state, error),

  [combineActions(
    deleteAccount,
    deleteAccountSuccess,
  )]:
    (state, { payload }) => state.merge({ resourcesById:
        state.resourcesById.filter((scheduledTransaction) => scheduledTransaction.transaction.accountId !== payload.id) }),

}, mkQcsSyncResourceStore());

export const SCHEDULED_TRANSACTIONS_REDUCER_KEY = 'scheduledTransactionsStore';
export default scheduledTransactionsReducer;
